import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import './loading_component.scss'

export const LoadingComponent = ({ requesting, message, overlay = true }) => {
  if (requesting) {
    return (
      <div styleName={overlay ? "overlay" : "no-overlay"}>
        <div styleName="load-container">
          <div styleName="loader"></div>
          { message && <div styleName="message">{message}</div> }
        </div>
      </div>
    )
  }

  return ''
}

LoadingComponent.propTypes = {
  requesting: PropTypes.bool.isRequired
}

LoadingComponent.defaultProps = {
  requesting: false
}

const mapStateToProps = state => ({
  requesting: state.requesting
})

export default connect(mapStateToProps)(LoadingComponent)
